<template>
  <div>
    <ul class="teacher-list">
      <li v-for="(item, index) in list" :key="index">
        <div class="teacher-card">
          <img :src="item.portrait" class="portrait" />
          <div class="teacher-card-content">
            <p class="name">{{ item.name }}</p>
            <p class="title">{{ item.title }}</p>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.teacher {
  &-list {
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;

    /* IE 10+ */
    &::-webkit-scrollbar {
      display: none;
      /* Chrome Safari */
    }

    > li {
      // display: inline-block;
      // margin-right: 0.4rem;
      padding: 0.53rem 0;
      border-bottom: 1px solid #ebecf0;

      &:last-child {
        border-bottom: 0;
      }
    }

    .teacher-card {
      width: 4.78rem;
      display: flex;

      &-content {
        flex: 1;
      }

      .portrait {
        width: 1.28rem;
        height: 1.28rem;
        margin-right: 0.43rem;
        border-radius: 100px;
      }

      .name {
        margin-top: 0.05rem;
        font-size: 0.37rem;
        margin-bottom: 0.1rem;
      }

      .title {
        color: #919499;
        font-size: 0.29rem;
      }
    }
  }
}
</style>
